export const countryLabels: Record<string, string> = {
  ext: "ext.",
  country: "Numéro de téléphone pays",
  phone: "Téléphone",
  AB: "Abkhazie",
  AC: "Île de l'Ascension",
  AD: "Andorre",
  AE: "Émirats Arabes Unis",
  AF: "Afghanistan",
  AG: "Antigua et Barbuda",
  AI: "Anguilla",
  AL: "Albanie",
  AM: "Arménie",
  AO: "Angola",
  AQ: "Antarctique",
  AR: "Argentine",
  AS: "Samoa américaines",
  AT: "Autriche",
  AU: "Australie",
  AW: "Aruba",
  AX: "île d'Åland",
  AZ: "Azerbaïdjan",
  BA: "Bosnie-Herzégovine",
  BB: "Barbade",
  BD: "Bangladesh",
  BE: "Belgique",
  BF: "Burkina Faso",
  BG: "Bulgarie",
  BH: "Bahrain",
  BI: "Burundi",
  BJ: "Bénin",
  BL: "St. Barthélemy",
  BM: "Bermudes",
  BN: "Brunéi",
  BO: "Bolivie",
  BQ: "Pays-Bas caribéens",
  BR: "Brésil",
  BS: "Bahamas",
  BT: "Bhoutan",
  BV: "Île Bouvet",
  BW: "Botswana",
  BY: "Biélorussie",
  BZ: "Belize",
  CA: "Canada",
  CC: "Ile des Cocos (Keeling)",
  CD: "République Démocratique du Congo",
  CF: "Centrafrique",
  CG: "Congo (République)",
  CH: "Suisse",
  CI: "Côte d'Ivoire",
  CK: "Iles Cook",
  CL: "Chili",
  CM: "Cameroun",
  CN: "Chine (République populaire)",
  CO: "Colombie",
  CR: "Costa Rica",
  CU: "Cuba",
  CV: "Iles du Cap-Vert",
  CW: "Curaçao",
  CX: "Ile Christmas (Océan indien)",
  CY: "Chypre",
  CZ: "Tchèque (République)",
  DE: "Allemagne",
  DJ: "Djibouti",
  DK: "Danemark",
  DM: "Dominique",
  DO: "Dominicaine (République)",
  DZ: "Algérie",
  EC: "Equateur",
  EE: "Estonie",
  EG: "Egypte",
  EH: "Sahara Occidental",
  ER: "Erythrée",
  ES: "Espagne",
  ET: "Ethiopie",
  FI: "Finlande",
  FJ: "Fidji",
  FK: "Iles Falkland",
  FM: "Micronésie (Etats fédérés)",
  FO: "Iles Féroé",
  FR: "France",
  GA: "Gabon",
  GB: "Grande-Bretagne et Irlande du Nord",
  GD: "Grenade",
  GE: "Géorgie",
  GF: "Guyane française",
  GG: "Guernsey",
  GH: "Ghana",
  GI: "Gibraltar",
  GL: "Groenland",
  GM: "Gambie",
  GN: "Guinée (République)",
  GP: "Guadeloupe",
  GQ: "Guinée équatorial",
  GR: "Grèce",
  GS: "Géorgie du Sud-et-les Îles Sandwich du Sud",
  GT: "Guatemala",
  GU: "Guam",
  GW: "Guinée-Bissau",
  GY: "Guyane",
  HK: "Hong-Kong",
  HM: "Îles Heard et Îles de McDonald",
  HN: "Honduras",
  HR: "Croatie",
  HT: "Haïti",
  HU: "Hongrie",
  ID: "Indonésie",
  IE: "Irlande",
  IL: "Israël",
  IM: "Ile de Man",
  IN: "Inde",
  IO: "Territoire britannique de l'Océan indien",
  IQ: "Iraq",
  IR: "Iran",
  IS: "Islande",
  IT: "Italie",
  JE: "Jersey",
  JM: "Jamaïque",
  JO: "Jordanie",
  JP: "Japon",
  KE: "Kenya",
  KG: "Kirghizistan",
  KH: "Cambodge",
  KI: "Kiribati",
  KM: "Comores",
  KN: "St. Christophe (St. Kitts) et Nevis",
  KP: "Corée, République populaire démocratique (Corée du Nord)",
  KR: "Corée, République (Corée du Sud)",
  KW: "Kuwait",
  KY: "Cayman",
  KZ: "Kazakhstan",
  LA: "Laos",
  LB: "Liban",
  LC: "St. Lucie",
  LI: "Liechtenstein",
  LK: "Sri Lanka",
  LR: "Liberia",
  LS: "Lesotho",
  LT: "Lituanie",
  LU: "Luxembourg",
  LV: "Lettonie",
  LY: "Libye",
  MA: "Maroc",
  MC: "Monaco",
  MD: "Moldavie",
  ME: "Monténégro, République",
  MF: "St. Martin",
  MG: "Madagascar",
  MH: "Îles Marshall",
  MK: "ex-République yougoslave de Macédoine",
  ML: "Mali",
  MM: "Myanmar",
  MN: "Mongolie",
  MO: "Macao",
  MP: "Îles Mariannes",
  MQ: "Martinique",
  MR: "Mauritanie",
  MS: "Montserrat",
  MT: "Malte",
  MU: "Ile Maurice",
  MV: "Maldives",
  MW: "Malawi",
  MX: "Mexique",
  MY: "Malaisie",
  MZ: "Mozambique",
  NA: "Namibie",
  NC: "Nouvelle-Calédonie",
  NE: "Niger",
  NF: "Île Norfolk",
  NG: "Nigeria",
  NI: "Nicaragua",
  NL: "Pays-Bas",
  NO: "Norvège",
  NP: "Népal",
  NR: "Nauru",
  NU: "Niue",
  NZ: "Nouvelle-Zélande",
  OM: "Oman",
  OS: "Ossétie du Sud-Alanie",
  PA: "Panama",
  PE: "Pérou",
  PF: "Polynésie française",
  PG: "Papouasie-Nouvelle-Guinée",
  PH: "Philippines",
  PK: "Pakistan",
  PL: "Pologne",
  PM: "St. Pierre et Miquelon",
  PN: "Îles Pitcairn",
  PR: "Porto Rico",
  PS: "Palestine",
  PT: "Portugal",
  PW: "Palaos",
  PY: "Paraguay",
  QA: "Qatar",
  RE: "Île de la Réunion",
  RO: "Roumanie",
  RS: "Serbie, République",
  RU: "Russie (Fédération de)",
  RW: "Rwanda",
  SA: "Arabie Saoudite",
  SB: "Iles Salomon",
  SC: "Seychelles",
  SD: "Soudan",
  SE: "Suède",
  SG: "Singapour",
  SH: "St. Hélène, Ascension et Tristan da Cunha",
  SI: "Slovénie",
  SJ: "Svalbard et île Jan Mayen SK Slovaque (République)",
  SK: "Slovaquie",
  SL: "Sierra Leone",
  SM: "St-Marin",
  SN: "Sénégal",
  SO: "Somalie",
  SR: "Suriname",
  SS: "Soudan du Sud",
  ST: "St. Thomas et Prince",
  SV: "El Salvador",
  SX: "St-Martin (Pays-Bas)",
  SY: "Syrie",
  SZ: "Swaziland",
  TA: "Île Tristan da Cunha",
  TC: "Turques et Caïques",
  TD: "Tchad",
  TF: "Terres australes et antarctiques françaises",
  TG: "Togo",
  TH: "Thaïlande",
  TJ: "Tadjikistan",
  TK: "Tokelau",
  TL: "Timor oriental",
  TM: "Turkménistan",
  TN: "Tunisie",
  TO: "Tonga",
  TR: "Turquie",
  TT: "Trinité et Tobago",
  TV: "Tuvalu",
  TW: "Taiwan (Taipei chinois)",
  TZ: "Tanzanie",
  UA: "Ukraine",
  UG: "Ouganda",
  UM: "Iles mineures éloignées des États-Unis",
  US: "États-Unis d'Amérique",
  UY: "Uruguay",
  UZ: "Ouzbékistan",
  VA: "Vatican",
  VC: "St. Vincent et Grenadines",
  VE: "Venezuela",
  VG: "Iles britanniques Vierges (Tortola)",
  VI: "Îles Vierges (États-Unis)",
  VN: "Viêt-Nam",
  VU: "Vanuatu",
  WF: "Wallis et Futuna",
  WS: "Samoa",
  XK: "Kosovo",
  YE: "Yemen",
  YT: "Mayotte",
  ZA: "Afrique du Sud",
  ZM: "Zambie",
  ZW: "Zimbabwe",
  ZZ: "International",
};
